"use strict";
/*
 * Copyright (C) 2017  Universidade de Aveiro, DETI/IEETA, Bioinformatics Group - http://bioinformatics.ua.pt/
 *
 * This file is part of Dicoogle/dicoogle-client-js.
 *
 * Dicoogle/dicoogle-client-js is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Dicoogle/dicoogle-client-js is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with Dicoogle.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = void 0;
const endpoints_1 = __importDefault(require("./endpoints"));
const util_1 = require("./util");
class UserService {
    constructor(socket) {
        this.socket = socket;
    }
    /** List all registered users.
     */
    list(callback) {
        return util_1.andCall(this.socket.get(endpoints_1.default.USER)
            .then((res) => res.body.users), callback);
    }
    /** Create a new user for Dicoogle.
     *
     * @param username the new identifier of the user
     * @param password the new password
     * @param admin whether the account is an administrator
     */
    add(username, password, admin, callback) {
        return util_1.andCall(this.socket.post(endpoints_1.default.USER).query({ username, password, admin })
            .catch((err) => {
            if (err.status === 405) {
                // method not allowed means that we're using Dicoogle 2,
                // so we try again with the PUT method
                return this.socket.put(endpoints_1.default.USER).query({ username, password, admin });
            }
            throw err;
        })
            .then((res) => res.body.success), callback);
    }
    /** Remove an existing user from the platorm.
     *
     * @param username the identifier of the user to remove
     */
    remove(username, callback) {
        return util_1.andCall(this.socket.request('DELETE', [endpoints_1.default.USER, username])
            .then((res) => res.body.success), callback);
    }
}
exports.UserService = UserService;
//# sourceMappingURL=users.js.map